import React, { useEffect } from "react";
import clsx from "clsx";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import DGAlert from "../../component/alert";
import Button from "@material-ui/core/Button";
import { isMobile } from "react-device-detect";
import { api } from "../../api";
import Layout from "../../container/layout";
import EventHeader from "../../container/event/header";
import { useNavigate, useParams } from "react-router-dom";
import { initPage } from "../home/action";
import { conditionText, inituser, login, startQuiz } from "./action";
import moment from "moment";
import { dateTH } from "../../utils";

const useStyles = makeStyles((theme) => ({
  bg: {
    backgroundImage: "url('/photo/bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center bottom",
    [theme.breakpoints.up("xs")]: {
      padding: 16,
    },
    [theme.breakpoints.down("xs")]: {
      backgroundImage: "none",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  loginDesc: {
    color: "#585251",
    fontSize: 18,
    paddingTop: 16,
  },
  loginTime: {
    fontSize: 18,
    color: "#C92028",
    paddingBottom: 32,
  },
  titleSpace: {
    margin: 16,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 18,
      lineHeight: "32px",
    },
  },
  mainLogin: {
    maxWidth: 953,
    margin: "0 auto",
    border: "1px solid #EFEFEF",
    textAlign: "center",
    padding: "50px 0 64px 0",
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
      padding: "32px 0 64px 0",
    },
    [theme.breakpoints.up("xs")]: {
      marginTop: 30,
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
    },
  },
  button: {
    marginTop: 16,
    width: "490px",
    height: "70px",
    padding: "19px 152px",
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 501,
    [theme.breakpoints.down("xs")]: {
      width: "273px",
      height: "56px",
      fontSize: 18,
      lineHeight: "32px",
      padding: 0,
    },
  },
  banner: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: 58,
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: 113.51,
    },
    width: "100%",
    maxWidth: 953,
    maxHeight: 250,
    objectFit: "cover",
    margin: "0 auto",
    color: "#000000",
    textAlign: "center",
    "& img": {
      width: "100%",
      maxWidth: 953,
      maxHeight: 250,
      objectFit: "cover",
    },
  },
  subtitle: {
    fontSize: 25,
    fontWeight: 700,
    lineHeight: "30px",
    margin: "32px 0 32px 0",
  },
  content: {
    whiteSpace: "pre-wrap",
    textAlign: "left",
    fontSize: 18,
    lineHeight: "32px",
    color: "#585251",
    fontWeight: 400,
    padding: "0 100px 0 100px",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
      padding: "0 16px 0 16px",
    },
  },
  textheaderlogin: {
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px 0 16px",
    },
  },
  accept: {
    marginTop: 64,
    textAlign: "center",
    padding: "0 100px 0 100px",
    [theme.breakpoints.down("xs")]: {
      marginTop: 50,
      padding: 16,
      textAlign: "left",
    },
  },
  labelaccept: {
    fontWeight: 501,
    "& span": {
      fontSize: 18,
      lineHeight: "32px",
    },
  },
}));

const Condition = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [values, setValues] = React.useState({
    start_date: "",
  });

  const [state, setState] = React.useState({
    agree: false,
    open: true,
    alert: false,
    error: {},
    errorText: {},
    snack: false,
    snackMsg: "",
    alertTitle: "",
    event: { banner_inside_mobile: [], banner_inside_desktop: [] },
  });

  const [condition, setCondition] = React.useState("");

  const handleStart = () => {
    // window.localStorage.removeItem("_quiz");

    const { endDate, isBetween } = state.event.eventTime;

    // const [sh, sm] = state.event.timestart_exam.split(":").map(Number);
    // const [eh, em] = state.event.timeend_exam.split(":").map(Number);

    // const sDate = moment(state.event.examdate_at).set({
    //   hours: sh,
    //   minutes: sm,
    // });

    // const eDate = moment(state.event.examdate_end).set({
    //   hours: eh,
    //   minutes: em,
    // });

    if (isBetween) {
      startQuiz(id, state.event.slugurl, navigate);
    } else {
      // const endDate = moment().isAfter(eDate);
      if (endDate && state.event.timer_exam) {
        setState({
          ...state,
          open: false,
          alert: true,
          alertTitle: "ไม่สามารถทำแบบทดสอบได้",
          errorText: {
            error: "เนื่องจากคุณได้ส่งคำตอบหรือหมดเวลาทำแบบทดสอบแล้ว",
          },
        });
      } else {
        startQuiz(id, state.event.slugurl, navigate);
      }
    }
  };

  const handleSnackClose = () => {
    setState({ ...state, snack: false });
  };

  const alertConfirm = () => {
    setState({ ...state, alert: false });
  };

  const checkUser = async () => {
    const data = await inituser(state.event.assetId, state.event.slugurl, navigate);
    if (data.result && data.payload.passed) {
      navigate(`/quiz/${state.event.assetId}/complete`);
    }
  };

  const classes = useStyles();

  useEffect(() => {
    initPage(state, setState, id, navigate, "login");
  }, []);

  useEffect(() => {
    if (state.event?.assetId) {
      // if(state.event?.active)
      // navigate("/process");

      checkUser();
      conditionText(state.event.questionform_id, setCondition, state, setState);
    }
  }, [state.event]);

  return (
    <div className={classes.bg}>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={state.snack} onClose={handleSnackClose} message={state.snackMsg} />
      <Backdrop className={classes.backdrop} open={state.open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DGAlert
        title={!!state.alertTitle ? state.alertTitle : "แจ้งเตือน"}
        description={Object.keys(state.errorText).map((e, k) => (
          <div key={k}>{state.errorText[e]}</div>
        ))}
        open={state.alert}
        onConfirm={alertConfirm}
        labelConfirm="ปิด"
      />

      <div className={classes.banner}>
        <img
          src={isMobile ? `${process.env.REACT_APP_API_URL}/images/${!!state.event?.banner_inside_mobile ? state.event?.banner_inside_mobile[0] : ""}` : `${process.env.REACT_APP_API_URL}/images/${!!state.event?.banner_inside_desktop ? state.event?.banner_inside_desktop[0] : ""}`}
          alt=""
          width="100%"
        />
      </div>

      <Layout>
        <div className={classes.mainLogin}>
          <div className={classes.textheaderlogin}>
            <EventHeader title={state?.event?.assetName} description={state?.event?.des2} />

            <div className={classes.subtitle}>ข้อกำหนดและเงื่อนไข</div>
          </div>

          <div
            className={classes.content}
            dangerouslySetInnerHTML={{
              __html: state.event?.qgroupDes,
            }}
          />

          <Grid item xs={12}>
            <div className={classes.accept}>
              <FormControlLabel className={classes.labelaccept} onChange={(v) => setState({ ...state, agree: v.target.checked })} control={<Checkbox color="primary" name="policy" />} label={<span style={{ color: "#292726", fontWeight: 501 }}>ข้าพเจ้ายอมรับ ข้อกำหนดและเงื่อนไขการสมัคร</span>} />
            </div>

            <Button variant="contained" color="primary" className={classes.button} onClick={handleStart} disabled={!state.agree}>
              เริ่มทำแบบทดสอบ
            </Button>
          </Grid>
        </div>
      </Layout>
    </div>
  );
};

export default Condition;
